<template>
	<div class="container page">
		<div class="header">
			<van-nav-bar :title="$t('other.deposit_history')" class="nav-bar">
				<template #left>
					<van-icon name="arrow-left" color="#fff" @click="back()" />
				</template>
			</van-nav-bar>
		</div>
		<div class="main">
			<div class="item_list">
				<div class="topInfo">
					<span>{{$t("withdraw.money")}}：{{info.amount}}</span>
				</div>
				<div class="desc">
					<span>{{$t("withdraw.order_sn")}}：{{info.order_sn}}</span>
				</div>
				<div class="time">
					<span>{{$t("withdraw.submit_time")}}：{{info.createtime_text}}</span>
				</div>
				<div class="time">
					<span>{{$t("withdraw.desc")}}：{{info.reason}}</span>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				info: {},
				id: this.$route.query.id
			};
		},
		created() {
			this.getRechargeInfo();
		},
		methods: {
			back() {
				return window.history.back();
			},
			getRechargeInfo() {
				this.$http({
					method: 'get',
					url: 'getRechargeInfo',
					data: {
						id: this.id
					}
				}).then(res => {
					if (res.code === 1) {
						this.info = res.data;
					} else {
						this.$toast(res.msg);
					}
				})
			}
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-loading__text {
		color: #000000;
		font-size: 35px;
	}

	.container .main {
		position: relative;
		background-color: #f2f2f5;
		height: 100%;
		padding: 0 10px;
	}

	.item_list {
		padding: 15px 15px;
		margin: 30px 10px;
		background: #fff;
		border-radius: 10px;
		line-height: 60px;
	}

	.item_list .topInfo span {
		flex: 1;
		font-size: 30px;
		font-weight: 700;
		color: #ff253f;
	}

	.item_list .time span {
		flex: 1;
		font-size: 25px;
		font-weight: 500;
		color: #000;
	}

	.item_list .topInfo span:last-child {
		float: right;
	}

	.item_list .desc span {
		font-size: 25px;
		font-weight: 700;
		color: #9b9b9b;
	}
</style>